import React from "react";
import ajax from "./../lib/ajax.js";
import { Redirect, browserHistory } from "react-router";
import Immutable from "immutable";
import TCClockEdit from "./tc-clock-edit.jsx";
import DurationTC from "./tc-entry-duration.jsx";
import TcEntryClockTc from "./tc-entry-clocktc.jsx";
import security from "../lib/security.js";

export default class TCEntry extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            timecardType: null
        }

        console.log(props);
    }

    componentDidMount() {        
        const self = this;
        ajax.api()
            .get("verify-ip")
            .then(function (res) {
                
                let tid = self.props.location.query.tid;

                ajax.api()
                    .get(`people/tc-type/${tid}`)
                    .then(function (res) {
                        const result = res.data;
                        self.setState(Immutable.fromJS(self.state)
                            .mergeDeep({ timecardType: result })
                            .toJS());
                    });
            });
    }

    render() {
        const content = (this.state.timecardType === "CLOCKTC" && this.props.location.query.edit == "1") || this.state.timecardType === "CLOCKEDITTC" ?
            <TCClockEdit location={this.props.location} params={this.props.params} 
                         route={this.props.route} routes={this.props.routes} durationTcRoute="people/tc-entry?edit=1&tid=:timecardId"/> : 
            this.state.timecardType === "DURATIONTC" ? 
            <DurationTC location={this.props.location} params={this.props.params} 
            route={this.props.route} routes={this.props.routes} clockeditTcRoute="people/tc-entry?edit=1&tid=:timecardId"/> : 
            this.state.timecardType === "CLOCKTC" ?
            <TcEntryClockTc location={this.props.location} params={this.props.params}
            route={this.props.route} routes={this.props.routes}/> : null;

        return (<div>
            {content}
        </div>);
    }
}